import humps from 'lodash-humps-ts';
import { snakes } from '@utils/lodash';
import { authAxios } from '@components/Auth';
import { HealthClaimBillingItem } from '@models/HealthClaimBillingItem';
import { API_V1_BASE } from '@config';

export type GetAllHealthClaimBillingItemParams = { healthClaimId: number };

export type BulkCreateItemPayload = {
  billingItemId: number;
  policyBenefitLimitId: number;
  itemName: string;
  subBenefit: string;
  priceAmount: string;
  quantity: number;
  discountPercentage: string;
};

export type BulkCreateHealthClaimBillingItemParams = {
  healthClaimId: number;
  items: BulkCreateItemPayload[];
};

export type UpdateHealthClaimBillingItemParams = {
  id: number;
  priceAmount: string;
  quantity: number;
  discountPercentage: string;
};

export type DeleteHealthClaimBillingItemParams = { id: number };

export class HealthClaimBillingItemApi {
  static getAll = async ({ healthClaimId }: GetAllHealthClaimBillingItemParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/health_claim_billing_items`, { params: { health_claim_id: healthClaimId } })
      .then((response) => humps(response.data) as HealthClaimBillingItem[]);
  };

  static bulkCreate = async ({ healthClaimId, items }: BulkCreateHealthClaimBillingItemParams) => {
    return await authAxios
      .post(`${API_V1_BASE}/user/health_claim_billing_items`, {
        health_claim_id: healthClaimId,
        items: items.map((item) => snakes(item)),
      })
      .then((response) => humps(response.data) as HealthClaimBillingItem[]);
  };

  static update = async ({ id, ...rest }: UpdateHealthClaimBillingItemParams) => {
    return await authAxios
      .put(`${API_V1_BASE}/user/health_claim_billing_items/${id}`, snakes(rest))
      .then((response) => humps(response.data) as HealthClaimBillingItem);
  };

  static delete = async ({ id }: DeleteHealthClaimBillingItemParams) => {
    return await authAxios
      .delete(`${API_V1_BASE}/user/health_claim_billing_items/${id}`)
      .then((response) => humps(response.data) as HealthClaimBillingItem);
  };
}
